/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ReasoningStepKindLlmTurn = zod.enum(['llm_turn']);

export type ReasoningStepKindLlmTurn = zod.input<typeof ReasoningStepKindLlmTurn>;
export type ReasoningStepKindLlmTurnOutput = zod.output<typeof ReasoningStepKindLlmTurn>;
